var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSubtitles = function SvgSubtitles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 23,
    height: 14,
    x: 0.5,
    y: 5,
    ry: 2.5
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61 15.332a3.422 3.593 78.898 0 1-3.635-1.393 3.422 3.593 78.898 0 1-.04-3.766 3.422 3.593 78.898 0 1 3.604-1.59M17.605 15.283a3.422 3.593 78.898 0 1-3.635-1.393 3.422 3.593 78.898 0 1-.04-3.766 3.422 3.593 78.898 0 1 3.604-1.59"
  })));
};
export default SvgSubtitles;